import { getCookie } from '../../plugins/utils'

let returnState = null

export function leadListScope (route) {
  const token = getCookie('workbench_token')
  const agentId = (route && route.query && route.query.agentId) || getCookie('workbench_agentId')
  return token ? JSON.stringify([token, agentId || '']) : ''
}

export function saveLeadListState (scope, state) {
  // Return navigation keeps filters in memory only; contact searches never enter URLs or browser storage.
  returnState = scope ? { scope, state: JSON.parse(JSON.stringify(state)) } : null
}

export function takeLeadListState (scope) {
  const saved = returnState
  returnState = null
  return saved && saved.scope === scope ? saved.state : null
}

export function clearLeadListState () {
  returnState = null
}

export function captureListScroll (element) {
  const ancestors = []
  for (let current = element; current; current = current.parentElement) {
    ancestors.push({ top: current.scrollTop, left: current.scrollLeft })
  }
  return { ancestors, top: window.pageYOffset, left: window.pageXOffset }
}

export function restoreListScroll (element, scroll) {
  if (!scroll) return
  let current = element
  ;(scroll.ancestors || []).forEach(position => {
    if (!current) return
    current.scrollTop = position.top
    current.scrollLeft = position.left
    current = current.parentElement
  })
  window.scrollTo(scroll.left || 0, scroll.top || 0)
}
